module.exports = __webpack_public_path__ + "img/昭和園.c0f3d516.svg";